import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ToastService } from '../../../common-services/Toast/ToastService';
import { CallbackResultType } from '../../../enums/CallbackResultType';
import { strings } from '../../../resources/strings';
import { ReportService } from '../ReportService';
import { GenerateLensSeparationListReportInput } from './GenerateLensSeparationListReportInput';

export class GenerateLensSeparationListReportService extends HttpServiceBase {

  constructor(
    private report: ReportService,
    private toaster: ToastService,
    http?: any | null
  ) {
    super(http);
  }

  handlePdf = (input: GenerateLensSeparationListReportInput, callback?: (resultType: CallbackResultType) => void) => {
    this.http.postToDownloadFile<GenerateLensSeparationListReportInput>(
      `${this.baseUrlSislogV2Api}/v2/report-lens-separation-list/pdf`,
      input
    ).then(result => {
      this.report.openPdf(result);
      callback?.(CallbackResultType.Success);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingReport);
      callback?.(CallbackResultType.Error);
    });
  }

  handleCsv = (input: GenerateLensSeparationListReportInput, callback?: (resultType: CallbackResultType) => void) => {
    this.http.postToDownloadFile<GenerateLensSeparationListReportInput>(
      `${this.baseUrlSislogV2Api}/v2/report-lens-separation-list/csv`,
      input
    ).then(result => {
      this.report.download(result, `${strings.LensSeparationList}.csv`);
      callback?.(CallbackResultType.Success);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
      callback?.(CallbackResultType.Error);
    });
  }
}